import { toast } from 'react-toastify';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import chatService from '../../services/chat.service';
import { useNavigate } from 'react-router-dom';
import config from '../../config';

export function RouletteMatchScreen({ recipientId, userAPhotoUrl, userBPhotoUrl, close }) {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const handleToFindOrCreateChat = async () => {
    if (!recipientId) return;
    try {
      const res = await chatService.getChatToUserId(axiosPrivate, recipientId);
      navigate(config.ROUTES.CHATS.TEXT(res.data._id));
    } catch (error) {
      console.error('[Roulette] getChatToUserId:', error);
      toast.error('Ошибка при попытке открыть чат с пользователем');
    }
  };

  return (
    <div className="fixed inset-0 z-50 [background:linear-gradient(180deg,rgb(1,13,13)_0%,rgb(3.01,42.5,42.5)_100%)] bg-[100%_100%] bg-repeat-y bg-cover w-full h-full flex flex-col items-center justify-center">
      <div className="flex items-center">
        <img
          className="w-[160px] h-[200px] object-cover z-10 rounded-[20px] -rotate-6 translate-x-1/4 shadow-2xl"
          src={userAPhotoUrl}
          alt="avatar"
        />
        <img className="size-[48px] z-10" src="/icons/match_heart.svg" alt="match_heart" />
        <img
          className="w-[160px] h-[200px] object-cover rounded-[20px] rotate-6 -translate-x-1/4 -translate-y-4 shadow-2xl"
          src={userBPhotoUrl}
          alt="avatar"
        />
      </div>
      <p className="mt-5 font-semibold text-[26px] px-4 text-center text-white raleway">
        Это взаимно! Не упусти шанс, напиши первым
      </p>

      <div className="absolute bottom-4 left-4 right-4  space-y-1">
        <button
          onClick={handleToFindOrCreateChat}
          className="flex items-center justify-center gap-1 w-full rounded-full bg-[#A1F69E] text-black p-[18.5px]"
        >
          <img src="/icons/chat-bubble-typing.svg" alt="chat-bubble-typing" />
          Написать
        </button>
        <button className="w-full rounded-full bg-transparent text-white p-[18.5px]" onClick={close}>
          Не сейчас
        </button>
      </div>
    </div>
  );
}
